import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../@types/RootState';

export type PriceCompositionData = {
  priceType: 'Preço vigente' | 'Novo preço' | 'PMZ';
  price: number;
  liquid_cost: {
    value: number;
    percentage: number;
  };
  profit: {
    value: number;
    percentage: number;
  };
  expenses: {
    value: number;
    percentage: number;
  };
  tax: {
    value: number;
    percentage: number;
  };
};

type PriceCompositionState = {
  isOpen: boolean;
  data: PriceCompositionData[] | null;
};

const initialState: PriceCompositionState = {
  isOpen: false,
  data: null,
};

const slice = createSlice({
  name: 'ipa.priceManager.modals.priceComposition',
  initialState,
  reducers: {
    SET_IS_OPEN: (state, action: PayloadAction<PriceCompositionState['isOpen']>) => {
      state.isOpen = action.payload;
    },
    SET_DATA: (state, action: PayloadAction<PriceCompositionData[] | null>) => {
      state.data = action.payload;
    },
  },
});

export const { SET_IS_OPEN, SET_DATA } = slice.actions;

export default slice.reducer;

export const selectorPriceComposition = (state: RootState) => {
  return state.ipa.priceManager.modals.priceComposition;
};
